var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPulse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.455 2h13.09C17.35 2 18 2.796 18 3.778V16.222c0 .982-.651 1.778-1.454 1.778H3.455C2.65 18 2 17.204 2 16.222V3.778C2 2.796 2.651 2 3.455 2ZM16.4 9.2V3.6H3.6v5.6h2.731l1.8 1.799 2.479-5.786L13.6 9.2h2.8ZM3.6 10.8h2.069l3 3.001 2.321-5.414L12.8 10.8h3.6v5.6H3.6v-5.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulse);
export default __webpack_public_path__ + "static/media/pulse.06846f1e.svg";
export { ForwardRef as ReactComponent };